import { defineStore } from "pinia";
import axios from "axios";


export const useDashboardStore = defineStore("dashboard", {
    state: () => {
        return {
            datas: [],
            tradeInfo: [],
            currents: [],
            pnls: [],
            lists: [],
            permits: [],
            profitCharts: [],
            initialbalances: 0,
            disableAccesss: true,
            loadings: false
        };
    },

    getters: {
        data: (state) => state.datas,
        disableAccess: (state) => state.disableAccesss,
        list: (state) => state.lists,
        initialbalance: (state) => state.initialbalances,
        tradesInfo: (state) => state.tradeInfo,
        current: (state) => state.currents,
        pnl: (state) => state.pnls,
        permit: (state) => state.permits,
        profitChart: (state) => state.profitCharts,
        loading: (state) => state.loadings
    },

    actions: {
        getAll(status) {
            this.loadings = true;
            this.lists = []
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'dashboard/all',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    status: status ? status : ""
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.lists = res?.data?.data?.dashboard
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        get(filters) {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'dashboard',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...filters
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.datas = res?.data?.data?.dashboard
                        this.initialbalances = res?.data?.data?.dashboard?.plan?.initialbalance
                        this.tradeInfo = res?.data?.data?.tradesInfo
                        this.currents = res?.data?.data?.current
                        this.permits = res?.data?.data?.permit
                        if (res?.data?.data?.dashboard?.plan) {
                            this.disableAccesss = false
                        }
                        else
                            this.disableAccesss = true
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        pnlChart(day, id) {
            this.loadings = true;
            this.pnls = []
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'dashboard/pnl',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    filter: day,
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.pnls = res.data.data.chart
                        this.loadings = false
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        pnlChartNoFilter() {
            this.loadings = true;
            const config = {
                method: "get",
                url: useRuntimeConfig().public.apiBase + 'dashboard/pnl',
                headers: {
                    usertoken: localStorage.token,
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.profitCharts = res.data.data.chart;
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
    },
});